import app from 'flarum/forum/app';

import { clippie } from '../util/clippie';

export const handleCopyIP = (ip: string) => {
  return async () => {
    await clippie(ip)
      .then(() => app.alerts.show({ type: 'success' }, app.translator.trans('fof-geoip.lib.alerts.ip_copied')))
      .catch(() => app.alerts.show({ type: 'error' }, app.translator.trans('fof-geoip.lib.alerts.ip_failed')));
  };
};
